import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'categoryFormatter',
})
export class CategoryFormatterPipe implements PipeTransform {
  transform(
    categories: any[],
    displayCount: number,
    otherValue?: string
  ): { display: string[]; tooltip: string } {
    if (!categories || categories.length === 0) {
      return { display: [], tooltip: '' };
    }

    let display =
      categories.length > displayCount
        ? [
            ...categories
              .slice(0, displayCount)
              .map((cat) => this.formate(cat.name, otherValue)),
            `+${categories.length - displayCount}`,
          ]
        : categories.map((cat) => this.formate(cat.name, otherValue));

    let tooltip = categories
      .map((cat) => {
        const Category = 'Others';
        if (cat.name === Category && otherValue) {
          return `${Category}(${otherValue})`;
        }
        return cat.name;
      })
      .join(', ');

    return { display, tooltip };
  }

  private formate(catName: string, otherValue?: string) {
    const Category = 'Others';
    if (catName === Category && otherValue) {
      return `${Category}(${otherValue})`;
    }

    return catName;
  }
}
